module.exports = __webpack_public_path__ + "img/mmeber.2c539771.svg";